export const CHECKOUT_TAGS_LOADING = 'CHECKOUT_TAGS_LOADING';
export const CHECKOUT_TAGS_ADDRESS_FORM = 'CHECKOUT_TAGS_ADDRESS_FORM';
